// Account owner roles (cfg.account_owner_roles) as delivered in
// globalConfigs.account_owner_roles by get_global_configs_v3: the role
// vocabulary for public.account_owners (primary RM, secondary RM, coverage,
// executive sponsor). is_exclusive = one current holder per account.
//
// Plain string ids, not .uuid(), so a lookup row can never blank the whole
// globalConfigs slice (the investor_parents precedent).
import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const AccountOwnerRoleModelSchema = z
  .object({
    id: z.string(),
    role_key: z.string(),
    label: z.string(),
    description: z.string().nullish(),
    is_exclusive: z.boolean(),
    sort_order: z.number()
  })
  .strict()

export const AccountOwnerRoleModelFields = makeFieldKeys(AccountOwnerRoleModelSchema)

export type AccountOwnerRoleModel = z.infer<typeof AccountOwnerRoleModelSchema>
